import { writable } from "svelte/store";

export let draft_open = writable(false);